import { useEffect, useRef, useState } from 'react'
import { SBack, STitle } from 'shj-components'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Button, Card, Checkbox, Form, Rate, Spin, message } from 'antd'
import { evaluationRecordDetail, evaluationSave } from '@/services/evaluateConfig'
import { trimObj } from '@/utils/data'
import TextArea from 'antd/es/input/TextArea'
import EvaluateRecordInfo from '../components/info'
import RecommendRate from '../components/recommendRate'

const EvaluateRecordEdit = () => {
    const formRefs = useRef<any>()
    const [searchParams] = useSearchParams({})
    const id = searchParams.get('id')
    const isModify = searchParams.get('isModify')
    const [form] = Form.useForm();
    const [pageData, setPageData] = useState<any>({})
    const [timeConsuming, setTimeConsuming] = useState(0);
    let timeFn;
    const [values, setValues] = useState([])
    const [recommendedLevel, setRecommendedLevel] = useState<any>(0)
    const [spinning, setSpinning] = useState<any>(false)
    const history = useNavigate()
    useEffect(() => {
        getDetail()
        timeFn = setInterval(timeDown, 1000)
        return () => {
            window.clearInterval(timeFn)
        }
    }, [])

    const timeDown = () => {
        setTimeConsuming(prevCount => prevCount + 1)
    }
    const getDetail = () => {
        setSpinning(true)
        evaluationRecordDetail(id).then(res => {
            if (res) {
                console.log('获取详情',res)
                setPageData(res)
                form.setFieldsValue({ evaluationRecords: res?.evaluationRecords||[] });
                setValues(res?.evaluationRecords||[]);
                setRecommendedLevel(res?.recommendedLevel||"")
            }
        }).finally(()=>{
            setSpinning(false)
        })
    }
    // 验证未评分
    const verificationFn = (list,checkFn)=>{
        for (const node of list) {
            if(checkFn(node)){
                return {
                    status: false,
                    label: node?.evaluationTitle,
                }
            }
        }
        return {
            status: true,
            label: "",
        }
    }
    // 验证还完成未评分
    const validateStarLevel = node => !node?.starLevel;
    // 验证有标签未选择标签
    const validateTag = (node) => {
        const isRequired = node?.isRequired;
        const starLevelLabel = node?.starLevelLabel;
        // 判断 starLevelLabel 是否为空或未定义
        const hasInvalidStarLevel = !starLevelLabel || !starLevelLabel.length;
        return isRequired && hasInvalidStarLevel;
    };
    // 提交
    const submit = () => {
        if(recommendedLevel === 0) {
            return message.warning('还未完成推荐值评分！');
        }
        form.validateFields().then((values: any) => {
            const result1 = verificationFn(values.evaluationRecords, validateStarLevel);
            if (!result1.status) {
                return message.error(`${result1.label}还未完成评分！`);
            }
            const result2 = verificationFn(values.evaluationRecords, validateTag);
            if (!result2.status) {
                return message.error(`${result2.label}还未选择标签！`);
            }
            // 处理数据
            const evaluationRecords = values.evaluationRecords.map((item) => {
                const {starLevel,starLevelLabel,id} = item;
                return {
                    id,
                    starLevel:starLevel||0,
                    starLevelLabel:starLevelLabel||[],
                };
            });
            let formObj:any = {
                evaluationRecords,
                "id": id,  //id
                "timeConsuming": timeConsuming,       //耗时
                "leaveMsg": values.leaveMsg,  //意见建议
                "recommendedLevel": recommendedLevel,
            }
            // 编辑
            if(isModify){
              formObj.isModify = true;
            }
            console.log('提交数据',formObj)
            formObj = trimObj(formObj, 'trim');
            setSpinning(true)
            evaluationSave({
                ...formObj
            }).then((res) => {
                setSpinning(false)
                message.success(res.message || "操作成功")
                history('/config/evalutionRecord')
            }).catch(() => {
                setSpinning(false)
            })
        })
    }
    const setPhone = (name, labelFlag) => {
        evaluationRecordDetail(id).then(res => {
            if (res) {
                formRefs?.current?.onFormRef()?.setFieldValue(name, res[name])
                pageData[name] = res[name]
                setPageData({ ...pageData })
            }
        })
    }
    const itemListDom = (field: any) => {
        const { name, } = field;
        const itemObj = values[name]||{};
        return (
            <>
                <span>{itemObj?.['evaluationTitle']}</span>
                <Form.Item
                    label={''}
                    name='starLevel'
                    required={true}
                >
                    <div style={{marginTop: '10px'}}>
                        <RecommendRate
                            isRate={true}
                            recommendedLevel={itemObj?.['starLevel']}
                            // recommendedLevel={itemObj?.['evaluationLevel']}
                            totalCount={itemObj.evaluationOptions?.['10']?10:5}
                            onChange={(value)=>{
                                if (value === 0) return;
                                const isRequired = !!(itemObj?.evaluationOptions[value]&&itemObj?.evaluationOptions[value].length>0);
                                // 获取当前表单值
                                const formData = form.getFieldsValue();
                                // 更新特定下标的值
                                formData.evaluationRecords[name] = { ...formData.evaluationRecords[name], starLevel: value,isRequired,starLevelLabel:[] };
                                // 设置新的表单值
                                form.setFieldsValue({ evaluationRecords: formData?.evaluationRecords||[] });
                                setValues(formData?.evaluationRecords||[] );
                            }}
                        />

                        <span style={{ paddingLeft: '10px' }}>{itemObj?.['starLevel'] ?? 0}分</span></div>
                        <Checkbox.Group
                            value={itemObj?.starLevelLabel||[]}
                            options={itemObj?.evaluationOptions[itemObj?.starLevel] ?? []}
                            onChange={value => {
                                // 获取当前表单值
                                const formData = form.getFieldsValue();
                                // 更新特定下标的值
                                formData.evaluationRecords[name] = { ...formData.evaluationRecords[name], starLevelLabel: value };
                                // 设置新的表单值
                                form.setFieldsValue({ evaluationRecords: formData.evaluationRecords });
                                setValues(formData.evaluationRecords);
                            }}
                        />
                </Form.Item>
            </>
        );
    }
    const handleNpsNumChange = (recommendedLevel) => {
        setRecommendedLevel(recommendedLevel);
    }
    return (
        <Spin spinning={spinning}>
            <SBack title={'详情'} level={2} extra={[<Button style={{ marginRight: '10px' }} onClick={() => { history(-1) }}>取消</Button>, <Button type="primary" onClick={submit}>提交</Button>]}>
                <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, paddingBottom: '40px' }}>
                    <EvaluateRecordInfo pageData={pageData} timeConsuming={timeConsuming} />
                    <Form
                        style={{ padding: "10px 0" }}
                        form={form}
                    >
                        <STitle titleMode={'edit'} style={{ marginBottom: 10 }} title={pageData.evaluationTitle} />
                        <Form.List name="evaluationRecords">
                            {(fields) => (
                                <>
                                    {fields.map((field) => {
                                        return itemListDom(field);
                                    })}
                                </>
                            )}
                        </Form.List>
                        <RecommendRate recommendedLevel={recommendedLevel} required={true} onChange={handleNpsNumChange}/>
                        <Form.Item
                            label={'其他建议或留言'}
                            name='leaveMsg'
                            layout='vertical'
                        >
                            <TextArea
                                maxLength={300}
                                placeholder="请输入其他建议或留言"
                                rows={3}
                                style={{ marginTop: '10px', width: '500px' }}
                            />
                        </Form.Item>
                    </Form>
                </Card>
            </SBack>
        </Spin>
    )
}

export default EvaluateRecordEdit
